import { gsap, ScrollTrigger, ScrollToPlugin } from "gsap/all";
import { BREAKPOINTS } from "../styles/variables/Breakpoints";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const parallax = target => {
  if (!target) return;
  const mm = gsap.matchMedia();

  mm.add(`(max-width: ${BREAKPOINTS.sm}px)`, context => {
    gsap.fromTo(
      target,
      { yPercent: -8 },
      {
        yPercent: 8,
        ease: "none",
        scrollTrigger: {
          trigger: target,
          scrub: 1,
        },
      }
    );
  });
};

const animations = {
  ...gsap,
  ScrollTrigger: ScrollTrigger,
  parallax: parallax,
};

export default animations;
